<app-modal-component [open]="openModal" [label]="'Members of ' + title">
  <div class="cf-shell cf-shell--wide">
    <app-form-wrapper [title]="title" (iconClick)="onClose.emit()" icon="close">
      <div class="cf">
        <p class="cf__lead">
          Members of this {{ groupName }}. Anyone you leave out gets no messages from
          this campaign; the {{ groupName }} itself does not change.
        </p>

        <!-- search -->
        <app-search-input label="Search members"
          class="gm__search"
          placeholder="Search by first name"
          (valueChange)="updateSearchTerm($event)"
        ></app-search-input>

        <!-- table -->
        <div class="gm__panel">
          <data-table label="Group members"
            [seamless]="true"
            [loading]="contactsService.isFetching"
            [maxHeight]="'420px'"
            [skeletonColumns]="4"
            [skeletonRows]="5"
            [resizable]="false"
          >
            @if (contacts.length) {
              <table class="bk-log">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col" class="col-phone">Phone number</th>
                    <th scope="col" class="col-email">Email</th>
                    <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
                  </tr>
                </thead>
                <tbody>
                  @for (contact of contacts; track $index) {
                    <tr [class.is-out]="isContactBlacklisted(contact.uuid!)">
                      <td class="col-name">
                        <span class="gm__name">{{ fullName(contact) }}</span>
                        @if (isContactBlacklisted(contact.uuid!)) {
                          <app-status text="Left out" status="disabled" />
                        }
                        <span class="gm__phone-inline">{{ contact.primaryContactNumber }}</span>
                      </td>
                      <td class="quiet col-phone">{{ contact.primaryContactNumber || "—" }}</td>
                      <td class="quiet col-email">{{ contact.emailAddress || "—" }}</td>
                      <td class="col-actions">
                        @if (isContactBlacklisted(contact.uuid!)) {
                          <button
                            type="button"
                            class="bk-icon-btn"
                            [attr.aria-label]="'Include ' + (fullName(contact) || 'this contact') + ' in this campaign again'"
                            matTooltip="Include again"
                            (click)="removeContactFromBlacklist(contact.uuid!)"
                          >
                            <span class="bk-sym" aria-hidden="true">person_add</span>
                          </button>
                        } @else {
                          <button
                            type="button"
                            class="bk-icon-btn"
                            [attr.aria-label]="'Leave ' + (fullName(contact) || 'this contact') + ' out of this campaign'"
                            matTooltip="Leave out of this campaign"
                            (click)="addContactToBlacklist(contact.uuid!)"
                          >
                            <span class="bk-sym" aria-hidden="true">person_remove</span>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p class="gm__empty">
                @if (searchTerm) {
                  No members match “{{ searchTerm }}”. Try another first name.
                } @else {
                  This {{ groupName }} has no members yet.
                }
              </p>
            }
          </data-table>
        </div>

        <!-- pagination -->
        @if (totalPages > 1) {
          <app-pagination
            (changePage)="updateContactsPage($event)"
            [currentPage]="contactsPage"
            (onNext)="goToNextPage()"
            (onPrev)="goToPreviousPage()"
            [pageSize]="params['size']"
            (pageSizeChange)="changePageSize($event)"
            [loading]="contactsService.isLoading || contactsService.isFetching"
            [totalPages]="totalPages"
          ></app-pagination>
        }

        <!-- save changes -->
        <div class="cf__foot">
          <customizable-button title="Cancel" [outline]="true" (click)="onClose.emit()" type="button" />
          <customizable-button
            title="Save members"
            type="button"
            [loading]="campaignsService.isLoading"
            (click)="saveChanges()"
          ></customizable-button>
        </div>
      </div>
    </app-form-wrapper>

    <!-- blacklist prompt -->
    @if (showBlacklistPrompt) {
      <app-prompt-card
        [openModal]="showBlacklistPrompt"
        title="Leave out contacts"
        buttonText="Leave them out"
        closeText="Go back"
        (onClose)="showBlacklistPrompt = false"
        (onButtonClick)="saveBlacklist()"
        [loading]="campaignsService.isLoading"
      >
        <p class="cf__prompt">
          The contacts you marked will get no messages from this campaign. You can
          include them again later.
        </p>
      </app-prompt-card>
    }
  </div>
</app-modal-component>
